<template>
  <div class="d-flex w-100">
      <!-- <div class="col-md-3">
        <QmaReportPainel @quantitativos="quantitativos" ref="painelQMA"></QmaReportPainel>
        <QmaReportFiltro @search="search"></QmaReportFiltro>
      </div> -->
      <QmaReportLvTable @dataRelatoioQmaLength="dataRelatoioQmaLength" @contagemPendentes="contagemPendentes" :report="report" v-if="report === 0" ref="tableRelatorioLvQMA"></QmaReportLvTable>
      <QmaReportPitTable @dataRelatoioQmaLength="dataRelatoioQmaLength" @contagemPendentes="contagemPendentes" :report="report" v-if="report === 1" ref="tableRelatorioPitQMA"></QmaReportPitTable>
      <QmaReportPivsTable @dataRelatoioQmaLength="dataRelatoioQmaLength" @contagemPendentes="contagemPendentes" :report="report" v-if="report === 2" ref="tableRelatorioPivsQMA"></QmaReportPivsTable>
  </div>
</template>

<script>
import qmaReport from './qmaReport'
export default qmaReport
</script>

<style scoped>
 .col-md-3{
  padding-right: 0;
  padding-left: 0;
 }
</style>



// WEBPACK FOOTER //
// src/views/private/qma/qmaReport/components/qmaReport/qmaReport.vue